<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i
      class="fa"
      [ngClass]="{ 'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise }"
      style="margin-right: 10px; cursor: pointer;"
      (click)="minimise = !minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body mdl-body" [hidden]="minimise">
  @if (loading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!loading && displayTable) {
<div class="table-wrapper">
    <table class="table nowrap table-bordered table-condensed table-hover sticky-header boldText custom-table">
      <thead>
        <tr>
          <th></th>
          @for (header of tableHeader; track $index) {
<th [hidden]="header === 'ROW_TYPE' || header === 'ACCOUNT_KEY'">{{ header }}</th>
}
        </tr>
      </thead>
      <tbody>
        @for (row of visibleRows; track $index) {
<tr>
          <td>
            @if (row.ROW_TYPE === 'EP') {
<a (click)="dispChildColumn(row)" style="cursor: pointer;">
              @if (!row.SHOW_DATA) {
<i class="fa fa-plus-square-o" aria-hidden="true"></i>
}
              @if (row.SHOW_DATA) {
<i class="fa fa-minus-square-o" aria-hidden="true"></i>
}
            </a>
}
          </td>
          @for (header of tableHeader; track $index) {
<td
           
            [hidden]="header === 'ROW_TYPE' || header === 'ACCOUNT_KEY'"
            [ngClass]="{ rightAlign: checkNumber(row[header]) }"
            style="padding: 0 10px 0 5px;">
            @if (!(header === 'Account' && row.ROW_TYPE === 'EP_Child')) {

              @if (checkNumber(row[header]) && header !== 'Account') {
<span>{{ row[header] | number }}</span>
}
              @if (!checkNumber(row[header]) || header === 'Account') {
<span>{{ row[header] }}</span>
}
            
}
          </td>
}
        </tr>
}
      </tbody>
    </table>
  </div>
}
</div>
